// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__10e4g","label":"Select_label__IOGQW"};